
    (async () => {
      const input = document.querySelector('.site-search-input');
      const resultsEl = document.getElementById('site-search-results');
      const statusEl = document.getElementById('site-search-status');
      if (!input || !resultsEl) return;

      // Announce the outcome through a permanently-visible-to-AT status element.
      // resultsEl itself cannot do this: it is display:none while being filled.
      function announce(message) {
        if (statusEl) statusEl.textContent = message;
      }

      let pagefind;
      try {
        const pagefindUrl = '/pagefind/pagefind.js';
        pagefind = await import(/* @vite-ignore */ pagefindUrl);
        await pagefind.options({ baseUrl: '/' });
      } catch {
        return; // Pagefind not available (dev mode)
      }

      let debounceTimer;
      input.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => doSearch(), 200);
      });

      // Close results on click outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.site-search')) {
          resultsEl.hidden = true;
        }
      });

      // Reopen on focus if there's a query
      input.addEventListener('focus', () => {
        if (input.value.trim() && resultsEl.innerHTML) {
          resultsEl.hidden = false;
        }
      });

      function esc(s) {
        const d = document.createElement('div');
        d.textContent = s;
        return d.innerHTML;
      }

      async function doSearch() {
        const query = input.value.trim();
        if (!query) { resultsEl.hidden = true; resultsEl.innerHTML = ''; announce(''); return; }
        const search = await pagefind.search(query);
        const results = await Promise.all(search.results.slice(0, 8).map(r => r.data()));
        if (!results.length) {
          resultsEl.innerHTML = '<p class="site-search-empty">No results found.</p>';
          announce('No results found.');
        } else {
          // The list is capped at 8, so report the cap explicitly rather than
          // announcing "8 results" when the query actually matched far more.
          const total = search.results.length;
          announce(total > results.length
            ? `Showing ${results.length} of ${total} results for ${query}.`
            : `${total} result${total === 1 ? '' : 's'} for ${query}.`);
          resultsEl.innerHTML = results.map(r =>
            `<a class="site-search-result" href="${esc(r.url)}">
              <span class="site-search-result-title">${esc(r.meta?.title || r.url)}</span>
              <span class="site-search-result-excerpt">${r.excerpt}</span>
            </a>`
          ).join('');
        }
        resultsEl.hidden = false;
      }
    })();
  